import React, { Component } from 'react';
import { Image, Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SettingsCard from './SettingsCard';
import Strings from '../../common/Strings';
import './PlanAndBilling.css';

class PlanAndBillingUsage extends Component {
  render() {
    const { projects, upcomingInvoice } = this.props;
    const activeMembers = new Set();
    projects.forEach(p => {
      p.teamMembers.forEach(t => {
        if (t.status === 'active') {
          activeMembers.add(t.email);
        }
      });
    });
    let currentAmountText;
    if (upcomingInvoice) {
      currentAmountText = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: this.props.upcomingInvoice.currency,
      }).format(this.props.upcomingInvoice.amountDue / 100);
    } else {
      currentAmountText = 'N/A';
    }

    return (
      <div>
        <p className="settings-card-title">{Strings.BILLING.currentUsage}</p>
        <p className="settings-card-subtitle">
          {Strings.BILLING.currentUsageInfo}
        </p>
        <SettingsCard>
          <div className="plan-and-billing-card-row-with-image">
            <Image
              className="plan-and-billing-image"
              src="/icon/billing_users.png"
            />
            <div
              style={{
                marginLeft: 10,
                marginTop: 'auto',
                marginBottom: 'auto',
              }}
            >
              <p className="settings-card-subtitle">
                {Strings.BILLING.connectedUsers}
                <Popup
                  trigger={
                    <Image
                      className="plan-and-billing-icon-popup-info"
                      src="/popup-question-mark.png"
                      style={{ width: 12, height: 12 }}
                    />
                  }
                  content={Strings.BILLING.popUpInfoConnectedMembers}
                  inverted
                />
              </p>
              <p className="plan-and-billing-card-row-value-bold">
                {activeMembers.size}
              </p>
            </div>
          </div>
          <div className="plan-and-billing-card-row-with-image">
            <Image
              className="plan-and-billing-image"
              src="/icon/billing_projects.png"
            />
            <div
              style={{
                marginLeft: 10,
                marginTop: 'auto',
                marginBottom: 'auto',
              }}
            >
              <p className="settings-card-subtitle">
                {Strings.BILLING.projects}
              </p>
              <p className="plan-and-billing-card-row-value-bold">
                {projects.length}
              </p>
            </div>
          </div>
          <div
            className="plan-and-billing-card-row"
            style={{ marginTop: 'auto', marginBottom: 'auto' }}
          >
            <p className="settings-card-subtitle">
              {Strings.BILLING.costThisMonth}
            </p>
            <p className="plan-and-billing-card-row-value-bold">
              {currentAmountText}
            </p>
          </div>
        </SettingsCard>
      </div>
    );
  }
}

PlanAndBillingUsage.defaultProps = {
  upcomingInvoice: null,
};

PlanAndBillingUsage.propTypes = {
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      teamMembers: PropTypes.arrayOf(
        PropTypes.shape({
          status: PropTypes.string,
          email: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  upcomingInvoice: PropTypes.shape({
    currency: PropTypes.string,
    amountDue: PropTypes.number,
  }),
};

const mapStateToProps = state => ({
  projects: state.projects,
  upcomingInvoice: state.upcomingInvoice.upcoming,
});

export default connect(mapStateToProps)(PlanAndBillingUsage);



// WEBPACK FOOTER //
// ./src/components/settings/PlanAndBillingUsage.js